<template>
  <div>
    <!-- DRAG + DROP AREA WRAPPER -->
    <div 
      class="dropzone"
      @dragover.prevent
      @drop="handleDrop"
      @dragenter.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
      :class="{ 'drag-active': isDragging }"
    >
    <div>
      <div v-show="!show_fileInput">
        <TemplatePopup :enableEdit="true" :isMessageTemplate="true" :messageTemplates="filtered_message_templates"
          @applyMessageTemplate="addTemplate" :textareaWidth="textareaWidth">
        </TemplatePopup>
      </div>
      <div v-show="show_fileInput">
        <v-file-input ref="uploader" accept="image/png, image/jpeg, image/bmp, image/gif, application/pdf, video/mp4"
          label="Upload Files" variant="underlined" multiple :show-size="1024" counter density="compact"
          color="deep-purple-accent-4" @change="onFileChanged" @click:clear="clearFiles" truncate-length="15">
          <template v-slot:selection="{ fileNames }">
            <div v-for="(fileName, index) in fileNames" :key="index">
              <v-chip v-if="index < 2" class="me-2" color="deep-purple-accent-4" size="small" label>
                {{ fileName }}
              </v-chip>

              <span v-else-if="index === 2" class="text-overline text-grey-darken-3 mx-2">
                +{{ selectedFiles?.length - 2 }} File(s)
              </span>
            </div>
          </template>
        </v-file-input>
      </div>
      <v-menu
        v-if="current_contact && current_contact.contact_id"
        :model-value="
          toggleMention && filteredUsers.length > 0 && !disablePopup
        " max-width="200" scroll-strategy="none" location="top" :offset="[0, -caretPosition.left]">
        <template v-slot:activator="{ props }">
          <div>
            <v-form v-model="valid" style="display: flex; gap: 10px; margin-bottom: -3px; margin-top: 5px;" v-if="sendTypeVal === 'Email' && current_contact?.email">
              <v-text-field v-model="subject" label="Subject" style="max-width: 150px;"  :rules="RULES.REQUIRED_FIELD('Subject')" variant="outlined" density="compact" ></v-text-field>
              <v-text-field v-model="cc"  label="CC" type="email" style="max-width: 150px;" :rules="RULES.EMAIL" variant="outlined" density="compact" ></v-text-field>
              <v-text-field v-model="bcc" label="BCC" type="email" style="max-width: 150px;" :rules="RULES.EMAIL" variant="outlined" density="compact" ></v-text-field>
            </v-form>
              <!-- TEXTAREA WITH PASTE SUPPORT -->
              <v-textarea
                v-bind="props"
                v-model="message"
                @paste="handlePaste"
                @click:append="reminderClicked()"
                @focus="focused = true"
                @blur="focused = false"
                @keyup="calculateMention"
                @keydown="checkKeyPressed"
                :disabled="(current_contact && !current_contact.contact_id) || disableTextarea"
                append-icon="mdi-alarm"
                auto-grow
                rows="1"
                filled
                :rounded="isRounded"
                :style="textareaStyle"
                @input="checkHeight"
                variant="solo-filled"
                placeholder="Type message"
                ref="textareaRef"
                id="vtextarea">
                 <template v-slot:prepend>
                  <v-icon :color="focused ? 'primary' : 'dark'" class="me-2" @click="toggleFileInput">
                    mdi-paperclip
                  </v-icon>
               </template>
              <template v-slot:prepend-inner>
                <v-icon @click="toggleTranslate" :color="iconcolor">{{
                  translateIcon
                  }}</v-icon>
                <v-icon
                  @click="requestUploadLink"
                  :color="focused ? 'primary' : 'dark'"
                  class="ml-1"
                  :disabled="requestingUploadLink"
                >
                  mdi-link-variant
                </v-icon>
              </template>
              <template v-slot:append-inner>
                    <!--  OD APPT API CALL LOADER  -->
                    <v-progress-circular
                      v-if="loadingAppt"
                      indeterminate
                      size="20"
                      color="deep-purple-accent-4"
                      class="mr-2"
                    />
                <v-icon :style="sendStyle" @click="sendTypeVal === 'Email' ? submitForm() : messageSent()" v-show="sendTypeVal === 'Text Message' || (sendTypeVal === 'Email' )"
                  @mouseup="sendStyle = 'margin-right: 5px'" @mousedown="
                    sendStyle = 'margin-right: 5px; background-color: #d3d3d3'
                    " :color="focused ? 'primary' : 'dark'">
                  mdi-send
                </v-icon>
                <v-icon v-if="deviceIcons.length == 1" :color="focused ? 'primary' : 'dark'">
                  {{ deviceTypeIcon }}
                </v-icon>
                <v-menu :open-on-hover="!isMobile" top offset-x max-width="60" v-else-if="deviceIcons.length >= 1">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" :color="focused ? 'primary' : 'dark'">
                      {{ deviceTypeIcon }}
                    </v-icon>
                  </template>
                  <v-list>
                    <v-list-item v-for="(icon, index) in deviceIcons" :key="index" @click="newDeviceClicked(index)"
                      :style="recentNumberBackground(index)">
                      <v-tooltip location="top" :text="calcRecommendedPhone(index)">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" :color="deviceTypeIcon === icon.icon ? 'primary' : 'dark'">
                            {{ icon.icon }}
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-textarea>
          </div>
        </template>
          <!-- USER @MENTIONS SCROLLER -->
        <RecycleScroller
          v-show="toggleMention && triggerChar === '@' && filteredUsers.length > 0"
          :items="filteredUsers"
          :minItemSize="25"
          :item-size="45"
          key-field="user_id"
          class="mention"
          v-slot="{ item }"
        >
          <v-hover v-slot="{ hover }">
            <div @click="userSelected(item)" style="display: flex; align-items: center; height: 45px" class="pl-2"
              :class="hover ? 'highlighted' : ''">
              <UserPopup noMenu dense :user_id="item.user_id" style="flex: 1" />
              <div style="
                  flex: 4;
                  display: flex;
                  flex-direction: column;
                  height: 45px;
                  justify-content: center;
                ">
                <span style="height: 15px; font-size: 13px" class="ml-2">{{
                  item.username
                  }}</span>
                <span style="font-size: 9px" class="ml-2">{{
                  item.first_name + " " + item.last_name
                  }}</span>
              </div>
            </div>
          </v-hover>
        </RecycleScroller>

          <!-- PLACEHOLDER SCROLLER ($name)and (@user) -->
        <RecycleScroller
          v-show="toggleMention && triggerChar === '$' && filteredPlaceholders.length > 0"
          :items="filteredPlaceholders"
          :minItemSize="25"
          :item-size="40"
          key-field="placeholder"
          class="mention"
          v-slot="{ item }"
        >
          <v-hover v-slot="{ hover }">
            <div
              @click="insertPlaceholder(item)"
              class="pl-2"
              :class="hover ? 'highlighted' : ''"
              style="cursor: pointer; height: 40px; display: flex; align-items: center;"
            >
              <v-icon size="18" class="me-1">mdi-chevron-right</v-icon>
              {{ item }}
            </div>
          </v-hover>
        </RecycleScroller>
      </v-menu>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";
import PlivoService from "@/services/plivoService";
import { phoneFormat } from "@/util/util";
import UserPopup from "@/components/Avatar/UserPopup";
import EventBus from "@/eventBus";
import TemplatePopup from "../CustomPopup.vue";
import odService from "../../services/odService";
import dayjs from "dayjs";
import { RULES } from "../../constants/validationRules.js";
import { isValidEmail } from "../../util/util.js";

export default {
  name: "FDMessengerBox",
  components: { UserPopup,TemplatePopup },
  props: {
    current_contact: { type: Object, default: null },
    contact: { type: Object, default: null },
    mostRecentNumber: { type: String, default: null },
    lastReceivedMsg: { type: Object, default: null },
  },
  data() {
    return {
      // selectedFiles: [],
      selectedFiles: [],
      focused: false,
      sendStyle: "margin-right: 5px",
      message: "",
      mention: "",
      toggleMention: false,
      deviceIcons: [], // list of valid devices
      deviceTypeIcon: null, // currently selected device
      otherIcon1: null, // list items
      otherIcon2: null,
      deviceDialog: false,
      // This is how we will identify where to place the @mentions pop-up, using the textarea-caret package
      // we will get the values of the fields 'left' and 'top,' while we will calculate 'topAdjusted'
      // ourselves based on the value we received for 'top.' Then, we will position the v-menu using the 'left'
      // and 'topAdjusted' fields, nudging the v-menu to the right by 'left' pixels and nudging the v-menu
      // to the bottom by 'topAdjusted pixels.'
      caretPosition: { left: 0, top: 0, topAdjusted: 0 },
      currMentionStartIndex: null,
      oldTop: 5,
      edgeCaseAdjustment: 0,
      prevAdjustmentResult: 3,
      textAreaHeight: null,
      mentionLength: -1,
      // This will be an object array that will hold all the mentions,
      // Each object will have the following fields:
      // 2) starting index of mention
      // 3) ending index of mention
      mentions: [],
      // Will hold the index of all the mentions that need to have their starting and
      // ending index update due to the message text either increasing or decreasing in
      // size.
      mentionIndicesToUpdate: [],
      disableTextarea: false, //prolly get rid of this!
      cursorOverMention: false,
      translateIcon: "mdi-translate",
      requestingUploadLink: false,
      basedOnLastMsg: true,
      iconcolor: "grey",
      sendIcons: [], // list of valid send methods (email, text)
      sendTypeIcon: null, // currently selected send method
      sendTypeVal: "", // Value of the currently selected send method,
      subject: "",
      cc: "",
      bcc: "",
      textareaHeight: 0,
      reminder_count : 0,
      show_fileInput : false,
      textareaWidth: 0,
      resizeObserver: null,
      templateSearchKeyword: '',
      loadingAppt: false,
      triggerChar: null,
      disablePopup: false,
      isDragging: false,
      _boundWindowDragleave: null, 
      RULES
    };
  },
  computed: {
    ...mapGetters(["isAdmin","firstName","getContactState"]),
    ...mapGetters("people", ["users"]),
    ...mapGetters("frontdesk",["odFilterSelectedValue","getOdTag","isODFilterContact","message_templates"]),
    ...mapGetters("window", ["isMobile"]),
    /*iconcolor(){
      return this.computeIconColor();
    },*/
    isSpanishContact() {
      console.log(" the language is: " + JSON.stringify(this.contact));
      return this.contact.language === "es";
    },
      messagePlaceholders() {
    return [
      "ApptDateWithTime",
      "ApptLocation",
      "TodayDayOfWeek",
      "userName",
      "contactName",
    ];
  },
  
    // filters the users based on the mention text
    filteredUsers: function () {
      if (!this.users) return [];

      let result = this.users.filter((user) => {
        const full = user.last_name ? `${user.first_name} ${user.last_name}` : "";

        return (
          user.username.toLowerCase().startsWith(this.mention.toLowerCase()) ||
          user.first_name.toLowerCase().startsWith(this.mention.toLowerCase()) ||
          (user.last_name && user.last_name.toLowerCase().startsWith(this.mention.toLowerCase())) ||
          full.toLowerCase().startsWith(this.mention.toLowerCase())
        );
      });

      let parts = this.mention.split(" ");
      let cutoffIndex = this.currMentionStartIndex + parts[0].length;

      if (result.length > 0 || this.cursorIndex() > cutoffIndex) return result;

      return this.users.filter((user) => {
        const full = user.last_name ? `${user.first_name} ${user.last_name}` : "";
        return (
          user.username.toLowerCase().startsWith(parts[0].toLowerCase()) ||
          user.first_name.toLowerCase().startsWith(parts[0].toLowerCase()) ||
          (user.last_name && user.last_name.toLowerCase().startsWith(parts[0].toLowerCase())) ||
          full.toLowerCase().startsWith(parts[0].toLowerCase())
        );
      });
    },

    filteredPlaceholders() {
      if (this.triggerChar !== '$') return [];
      const keyword = this.mention?.toLowerCase() || '';
      if (!keyword) {
        return this.messagePlaceholders;
      }
      return this.messagePlaceholders.filter(name =>
        name.toLowerCase().startsWith(keyword)
      );
    },

    showVMenu: function () {
      return (
        this.toggleMention &&
        this.filteredUsers.length > 0 &&
        !this.disablePopup
      );
    },

    isRounded() {
      return this.textareaHeight <= 80; 
    },

    textareaStyle() {
      return {
        maxHeight: "150px",
        overflowY: this.textareaHeight > 100 ? "auto" : "hidden", 
        borderRadius : this.textareaHeight > 100 ? "15px" : "", 
      };
    },

    filtered_message_templates(){
      const rawKeyword = this.message.match(/\/([^\s$]*)$/)?.[1]?.toLowerCase() || '';

      return this.message_templates.filter(item => {
        const title = (item.title || '').replace(/\s+/g, '').toLowerCase();
        const contactMatch = item.contact_type_id === 0 || item.contact_type_id === this.getContactState.contact_type;
        const titleMatch = !rawKeyword || title.includes(rawKeyword);
        return item.is_active && contactMatch && titleMatch;
      });
    }
  },
  mounted() {
 this._boundWindowDragleave = () => {
    this.isDragging = false;
  };
  window.addEventListener("dragleave", this._boundWindowDragleave);
    this.setIcons(); 
      this.setSendIcons();
    EventBus.$on("update-Reminder",(data)=>{ 
      if(data?.initial){
        this.reminder_count = data.reminder_count;
      }else{
        this.reminder_count += data.reminder_count;
      }
     
    });

    const textareaEl = this.$refs.textareaRef?.$el || this.$refs.textareaRef;
    if (textareaEl) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          this.textareaWidth = entry.contentRect.width;
        }
      });
      this.resizeObserver.observe(textareaEl);
    }
  },

  beforeUnmount(){
  if (this._boundWindowDragleave) {
    window.removeEventListener("dragleave", this._boundWindowDragleave);
    this._boundWindowDragleave = null;
  }
    EventBus.$off("update-Reminder");
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    // cleanup global listeners
    if (this._boundWindowDragover) {
      window.removeEventListener("dragover", this._boundWindowDragover);
      this._boundWindowDragover = null;
    }
    if (this._boundWindowDrop) {
      window.removeEventListener("drop", this._boundWindowDrop);
      this._boundWindowDrop = null;
    }
  },
  watch: {
    current_contact: function () {
      this.setIcons();
      this.message = "";
       this.setSendIcons();
       
    },
    // contact: function () {
    //   this.setIcons();
    //   this.setSendIcons();
    // },
    // sendTypeVal: function (newVal) {
    //  if (newVal === "Email") {
    //   this.includeFields();
    //  }else {
    //   this.subject = "";
    //   this.cc = "";
    //   this.bcc = "";
    //  }
    // },
  sendTypeVal(newVal) {
    if (newVal === "Email") {
      this.$nextTick(() => {
        this.valid = false; // force validation
      });
    } else {
      this.subject = "";
      this.cc = "";
      this.bcc = "";
      this.valid = true;
    }
  },
    message(newVal){
      if (this.message == "") this.calculateMention();
      const match = newVal.match(/\/(\w*)$/); 
      if (match) {
        this.templateSearchKeyword = match[1];
      } else {
        this.templateSearchKeyword = '';
      }
    },

    lastReceivedMsg: function () {
      this.iconcolor = this.computeIconColor();
    },

    showVMenu: function () {
      if (this.showVMenu == false) {
        this.edgeCaseAdjustment = 0;
      }
    },

    mention: function () {
      if (this.filteredUsers.length == 1 && this.toggleMention) {
        let fullName;
        if (this.filteredUsers[0].last_name) {
          fullName =
            this.filteredUsers[0].first_name.toLowerCase() +
            " " +
            this.filteredUsers[0].last_name.toLowerCase();
        } else {
          fullName = null;
        }
        if (
          this.filteredUsers[0].username.toLowerCase() ==
          this.mention.toLowerCase() ||
          this.filteredUsers[0].first_name.toLowerCase() ==
          this.mention.toLowerCase() ||
          fullName == this.mention.toLowerCase()
        ) {
          this.userSelected(this.filteredUsers[0]);
        }
      };
       if (this.filteredPlaceholders.length === 1 && this.toggleMention && this.triggerChar === '$') {
          this.insertPlaceholder(this.filteredPlaceholders[0]);
          this.toggleMention = false; 
          };
    },
  },

  methods: {
    computeIconColor() {
     
      let color = "grey";
      if (this.basedOnLastMsg && this.lastReceivedMsg) {
        if (this.lastReceivedMsg.src_language === "es") {
          color = "blue";
        } else {
          color = "grey";
        }
      } else {
        this.contact && this.contact.language === "es" ? (color = "blue") : (color = "grey");
      }
      return color;
 },
clearFiles() {
  this.selectedFiles = [];

  const input = this.$refs.uploader?.$el?.querySelector("input[type='file']");
  if (input) input.value = ""; // fully reset file buffer

  this.show_fileInput = false;
},
    // adds a message to the convo
    calcRecommendedPhone(index) {
      if (this.deviceIcons[index].icon === "mdi-email") {
      return this.current_contact.email + "\nRecommended Email";
      }
      let str = phoneFormat(this.deviceIcons[index].num);
      if (this.deviceIcons[index].num == this.mostRecentNumber)
      str += "\nRecommended Phone";
      return str;
    },

    setIcons() {
      if (!this.current_contact) return;

      this.deviceIcons = [];
      this.deviceTypeIcon = null;

      if (this.current_contact.ph1 && this.current_contact.textable1) {
        this.deviceIcons.push({ icon: "mdi-cellphone", num: this.current_contact.ph1, val : "Text Message" });
        if (this.current_contact.ph1 === this.mostRecentNumber)
          this.deviceTypeIcon = "mdi-cellphone";
      }
      if (this.current_contact.ph2 && this.current_contact.textable2) {
        this.deviceIcons.push({ icon: "mdi-home", num: this.current_contact.ph2, val : "Text Message" });
        if (this.current_contact.ph2 === this.mostRecentNumber)
          this.deviceTypeIcon = "mdi-home";
      }
      if (this.current_contact.ph3 && this.current_contact.textable3) {
        this.deviceIcons.push({ icon: "mdi-briefcase", num: this.current_contact.ph3, val : "Text Message" });
        if (this.current_contact.ph3 === this.mostRecentNumber)
          this.deviceTypeIcon = "mdi-briefcase";
      }
      if (this.current_contact.email) {
        this.deviceIcons.push({ icon: "mdi-email", val: "Email" });
      }
      if (this.deviceTypeIcon === null && this.deviceIcons.length > 0)
        this.deviceTypeIcon = this.deviceIcons[0].icon;
    },

    setSendIcons() {
      this.sendIcons = [...(this.deviceIcons || [])];

      if (this.sendIcons.length === 0) {
        this.sendTypeIcon = null;
        this.sendTypeVal = "";
        return;
      }

      if (this.sendIcons.length === 1 && this.sendIcons[0].icon === "mdi-email" && this.current_contact?.email) {
        this.sendTypeIcon = "mdi-email";
        this.sendTypeVal = "Email";
      } else {
        this.sendTypeIcon = "mdi-message-reply-text";
        this.sendTypeVal = "Text Message";
      }
    },

    recentNumberBackground(index) {
      const icon = this.deviceIcons[index];
      if (icon.icon === "mdi-email") {
      // Highlight email if it's the only option or if sendTypeIcon is email
      return this.sendTypeIcon === "mdi-email"
        ? "background-color: #d3d3d3"
        : "";
      }
      return icon.num == this.mostRecentNumber
      ? "background-color: #d3d3d3"
      : "";
    },

    async readFile(file, blob, encodedBlob) {
      var fr = new FileReader();
      fr.onload = async function () {
        var data = fr.result;
        console.log(data);
        blob = new Int8Array(data);
        encodedBlob = btoa(blob);
      };
      fr.readAsArrayBuffer(file);
      return encodedBlob;
    },
    // ---------- DRAG & DROP ----------
    handleDrop(e) {
      if (e) {
        try {
          e.preventDefault();
          e.stopPropagation();
        } catch (err) {
          console.error("The img drop error :",err);
        }
      }
      this.isDragging = false;
      const dt = e?.dataTransfer;
      if (!dt) return;
      const droppedFiles = Array.from(dt.files || []);
      if (!droppedFiles.length) return;

      this.addFilesToUploader(droppedFiles);
    },

    // ---------- PASTE HANDLER ----------
    handlePaste(e) {
      if (!e || !e.clipboardData) return;
      const items = e.clipboardData.items;
      let files = [];

      for (const item of items) {
        try {
          if (item.kind === "file") {
            const file = item.getAsFile();
            if (file) files.push(file);
          } else if (item.type && item.type.indexOf("image") === 0) {
            // some browsers put images as blob items too
            const blob = item.getAsFile();
            if (blob) files.push(blob);
          }
        } catch (err) {
         console.error("paste img error:",err);
        }
      }

      if (files.length > 0) {
        this.addFilesToUploader(files);
      }
    },

    // ---------- UNIFIED FILE ADD ----------
    addFilesToUploader(newFiles) {
      // normalize input to array
      const incoming = Array.from(newFiles || []);
      let updated = Array.isArray(this.selectedFiles)
        ? [...this.selectedFiles, ...incoming]
        : [...incoming];

      // Limit check (8 files)
      const MAX = 8;
      if (updated.length > MAX) {
        alert(`Maximum ${MAX} files allowed.`);
        updated = updated.slice(0, MAX);
      }
      this.show_fileInput =true;
      this.selectedFiles = updated;
      // Sync with v-file-input (create a FileList)
      if (this.$refs.uploader) {
        const input = this.$refs.uploader.$el.querySelector("input[type='file']");
        if (input) {
          try {
            input.files = this.createFileList(updated);
            // trigger change event for Vuetify to pick up (some versions)
            const ev = new Event("change", { bubbles: true });
            input.dispatchEvent(ev);
          } catch (err) {
            // Some browsers restrict setting input.files; we still keep selectedFiles.
            console.warn("Couldn't programmatically set input.files:", err);
          }
        }
      }
    },

    createFileList(filesArray) {
      const dt = new DataTransfer();
      filesArray.forEach((f) => dt.items.add(f));
      return dt.files;
    },

    // ---------- SEND MESSAGE (SMS) ----------
    async messageSent() {
      var dest = "";

      // non-contact
      if (this.current_contact && this.current_contact.phone_num) dest = this.current_contact.phone_num;
      else {
        // choses the destination number based on the icon chosen by user.
        let index = this.deviceIcons.findIndex(
          (element) => element.icon == this.deviceTypeIcon
        );

        if (index == -1) return;
        dest = this.deviceIcons[index].num;
      }

      let has_attachment = false;
      const formData = new FormData();

      if (this.selectedFiles && this.selectedFiles?.length > 0) {
        has_attachment = true;
        console.log(this.selectedFiles + ":::" + this.selectedFiles.length);

        console.log("The selected files are:", this.selectedFiles);
        for (var i = 0; i < this.selectedFiles.length; i++) {
          formData.append("files", this.selectedFiles[i]);
        }
      } else if (this.message == "") {
        return;
      }
      formData.append("dst", dest);
      formData.append("message_text", this.message);
      formData.append("has_attachment", has_attachment);
      formData.append("src", "1234567890");
      if (this.current_contact.contact_id && this.contact) {
        formData.append("translate", String(this.iconcolor === "blue"));// need to check when od filter applied it return's "true" or "false" in String format, without od filter it correctly return's boolean type.
      }
     
      // Applying Auto tag for the message when it is on OD filter.
      if(this.odFilterSelectedValue && this.isODFilterContact(this.current_contact.contact_id)){ // also check isContact is from OD
        if(this.getOdTag && this.getOdTag.enable_auto){
          const tagId = this.getOdTag.tag_id;
          formData.append("tag", tagId);
        }
      }
      console.log(this.contact);
      //const headers = { 'Content-Type': 'multipart/form-data' };
      PlivoService.sendMessage(formData);
      this.message = "";
      this.selectedFiles = [];
      try {
        this.$refs.uploader.reset();
      } catch (err) {
        console.error("the error file clear:(err)=>",err)
      }
      this.show_fileInput = false;
      EventBus.$emit("scroll-bottom");
    },

    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      if (this.$refs.uploader && this.$refs.uploader.$el) {
        const input = this.$refs.uploader.$el.querySelector("input[type='file']");
        if (input) input.click();
      } else if (this.$refs.uploader) {
        this.$refs.uploader.click && this.$refs.uploader.click();
      }
    },

    onFileChanged(event) {
      const files = event.target ? event.target.files : event;
      if (!files || files.length === 0) return;
      

      if (files.length > 8) {
        alert("Max number of files that can be attached is 8");
        this.$refs.uploader.reset();
        return;
      }

      console.log("files are:", files);
      // console.log("act files are:", files.target.files);
      this.selectedFiles = Array.from(files);
    },

    async toggleTranslate() {
      //do we need to have an option to stop translation
      console.log("this languate" + this.contact.language);
      console.log("The icon:" + JSON.stringify(this.$refs.textareaRef.$refs));
      /* if (this.contact.language === 'es') {
        let prependIcon=this.$refs.textarea.$refs["prepend-icon"]
        if (prependIcon === 'translate') {
          this.$refs.textarea.$refs["prepend-icon"] = 'translateOff'
        } else {
          this.$refs.textarea.$refs["prepend-icon"] = 'translate'
        }
        this.iconcolor = this.iconcolor === 'blue' ? 'grey' : 'blue';
      }*/
      this.iconcolor = this.iconcolor === "blue" ? "grey" : "blue";
      return;
    },

    async requestUploadLink() {
      if (!this.current_contact?.contact_id || this.requestingUploadLink) return;
      this.requestingUploadLink = true;
      try {
        const res = await odService.createUploadLink(this.current_contact.contact_id);
        const separator = this.message && !/\s$/.test(this.message) ? " " : "";
        this.message += `${separator}Please upload your document here: ${res.data.url}`;
      } catch (err) {
        console.error("Failed to create upload link:", err);
      } finally {
        this.requestingUploadLink = false;
      }
    },

    async userSelected(user) {
      let messageFirstHalf = this.message.slice(0, this.currMentionStartIndex);
      let mentionSplit = this.mention.split(" ");
      let messageSecondHalf;
      //console.log("in user selected: "+this.mention);
      if (mentionSplit.length > 1 && mentionSplit[1].length > 0) {
        if (
          this.filteredUsers.filter((e) => {
            if (e.last_name) {
              let fullName =
                e.first_name.toLowerCase() + " " + e.last_name.toLowerCase();
              return fullName.startsWith(this.mention.toLowerCase());
            } else {
              return false;
            }
          }).length > 0
        ) {
          messageSecondHalf = this.message.slice(
            this.currMentionStartIndex + this.mention.length
          );
        } else {
          messageSecondHalf = this.message.slice(
            this.currMentionStartIndex + mentionSplit[0].length
          );
        }
      } else {
        messageSecondHalf = this.message.slice(
          this.currMentionStartIndex + mentionSplit[0].length
        );
      }

      // Adding 6 spaces here to the message to account for the extended mention ui length
      // and 1 space extra so user doesn't have to hit spacebar.
      // Sike it's just 5 spaces actually.
      // Update: Ending up just adding 1 extra space to do the additional automatic spacebar after a mention
      // for the user.
      this.message = messageFirstHalf + user.username + " " + messageSecondHalf;

      // Getting starting and ending indices of mention
      let startIndex = parseInt(messageFirstHalf.length) - 1;
      let endIndex = startIndex + parseInt(user.username.length) + 1;
      console.log("startindex: " + startIndex);
      console.log("endindex: " + endIndex);

      // Toggle mention to false as we do not need the mention popup anymore
      this.toggleMention = false;

      // Creating new mention object
      let newMention = {
        start: startIndex,
        end: endIndex,
      };

      // Adding mention to our mentions object array
      this.mentions.push(newMention);

      // Here we are temporarily disabling the popup after the mention was created
      // so that if the person's username is also the first name of the individual
      // who was just mentioned, the pop up will not keep showing after they hit the
      // spacebar (since our program will then assume they are trying to still
      // pick the person to mention by typing in their last name, when in reality
      // the user had already picked the mention).
      this.disablePopup = true;
    },

    reminderClicked() {
      this.$emit("reminderClicked");
    },

    phoneClicked() {
      this.deviceDialog = true;
    },
newDeviceClicked(index) {
  const device = this.deviceIcons[index];
  this.deviceTypeIcon = device.icon;
  if (device.icon === "mdi-email") {
    this.sendTypeVal = "Email";
  } else {
    this.sendTypeVal = "Text Message";
  }
},

    checkKeyPressed(event) {
      if (event && event.key == "@") {
        // If the key pressed was an @ symbol we can re-enable to popup to show.
        this.disablePopup = false;
      }
    },

    calculateMention(event) {
  let cursorIndex;
  if (event && event.target) {
    cursorIndex = event.target.selectionEnd;
  } else {
    const textareaEl = this.$refs.textareaRef?.$el?.querySelector("textarea") || this.$refs.textareaRef?.$el;
    cursorIndex = textareaEl && textareaEl.selectionEnd ? textareaEl.selectionEnd : this.message.length;
  }
  const textBeforeCursor = this.message.slice(0, cursorIndex);

      // Detect last trigger character (@ or $) before cursor
      const atIndex = textBeforeCursor.lastIndexOf('@');
     const dollarIndex = textBeforeCursor.lastIndexOf('$');

      if (atIndex > dollarIndex) {
        this.triggerChar = '@';
        this.currMentionStartIndex = atIndex;
        this.mention = this.message.slice(atIndex + 1, cursorIndex);
      }
       else if (dollarIndex > atIndex) {
        this.triggerChar = '$';
        this.currMentionStartIndex = dollarIndex;
        this.mention = this.message.slice(dollarIndex + 1, cursorIndex);
      } 
      else {
        this.triggerChar = null;
        this.toggleMention = false;
        return;
      }
      this.toggleMention = true;
    },
    // gets the cursor index in the v-textarea
    cursorIndex() {
      try {
        let index =
          this.$refs.textareaRef.$el.$el.children[0].children[0].children[2]
            .children[1].selectionStart;
        return index;
      } catch (e) {
        return 0;
      }
    },

    phoneFormat,
    // includeFields() {
    //   // Include fields based on the selected options
    //   if (this.includeSubject) {
    //     this.message += "\nSubject: ";
    //   }
    //   if (this.includeCC) {
    //     this.message += "\nCC: ";
    //   }
    //   if (this.includeBCC) {
    //     this.message += "\nBCC: ";
    //   }
    // },
    async submitForm() {
      try {
        // Combine the fields into an object to send to the backend
        let has_attachment = false;
        const formData = new FormData();

        if (this.selectedFiles && this.selectedFiles.length > 0 ) {
          has_attachment = true;

          for (var i = 0; i < this.selectedFiles.length; i++) {
            formData.append('files', this.selectedFiles[i]);
          }
        } else if (this.message == "") {
          return;
        }
        if(this.subject.length === 0 || !this.subject) return ;
        if(this.cc && isValidEmail(this.cc) === false) return ;
        if(this.bcc && isValidEmail(this.bcc) === false) return ;


        formData.append('to', this.current_contact.email);
        formData.append('subject', this.subject);
        formData.append('cc', this.cc);
        formData.append('bcc', this.bcc);
        formData.append('message', this.message);
        formData.append('has_attachment', has_attachment);
        formData.append('isReply', false); // Not a reply to an email

      if(this.odFilterSelectedValue && this.isODFilterContact(this.current_contact.contact_id)){ // also check isContact is from OD
        if(this.getOdTag && this.getOdTag.enable_auto){
          const tagId = this.getOdTag.tag_id;
          formData.append("tag", tagId);
        }
      }

        let options = {
          method: "POST",
          url: process.env.VUE_APP_API_URL + "/api/mail/profile/sendMail",
          headers: {
            "Content-type": "multipart/form-data",
          },
          data: formData,

        };

        await axios.request(options);

        this.subject = "";
        this.cc = "";
        this.bcc = "";
        this.message = "";
        this.selectedFiles = [];
        try {
          this.$refs.uploader.reset();
        } catch (err) {
          console.error("the input file Couldn't reset Error:",err);
        }
        this.show_fileInput = false;
        EventBus.$emit("scroll-bottom");
      } catch (error) {
        console.error(error);
      }
    },

    checkHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.textareaRef?.$el;
        if (textarea) {
          this.textareaHeight = textarea.clientHeight;
        }
      });
    },
async addTemplate(template){
      if(this.templateSearchKeyword){
        this.message = this.message.slice(0, this.message.length - (this.templateSearchKeyword.length + 1));
      }
      const replaced = await this.replacePlaceholders(template);
      this.message += replaced;
    },

    toggleFileInput(){
      this.show_fileInput = !this.show_fileInput;
      if(this.show_fileInput){
        // prefer clicking the actual input inside v-file-input
        try {
          const input = this.$refs.uploader.$el.querySelector('input[type="file"]');
          if (input) input.click();
        } catch (err) {
          this.$refs.uploader && this.$refs.uploader.click && this.$refs.uploader.click();
        }
      }
    },

async insertPlaceholder(placeholder) {
  const textareaEl = this.$refs.textareaRef?.$el?.querySelector("textarea") || this.$refs.textareaRef.$el;
  if (!textareaEl) return;

  const start = textareaEl.selectionStart;
  const end = textareaEl.selectionEnd;

  const triggerCharIndex = this.message.lastIndexOf(this.triggerChar, start - 1);
  const wordStart = triggerCharIndex >= 0 ? triggerCharIndex : start;

  this.message =
    this.message.slice(0, wordStart + 1) + 
    placeholder +
    this.message.slice(end);

  // Move cursor to end of inserted placeholder
  this.$nextTick(() => {
    const newCursorPos = wordStart + 1 + placeholder.length;
    textareaEl.setSelectionRange(newCursorPos, newCursorPos);
    textareaEl.focus();
  });

  // Replace placeholders asynchronously
  const replaced = await this.replacePlaceholders(this.message);
  this.message = replaced;
}

,
async replacePlaceholders(text) {
      const data = {
        userName: this.firstName,
        contactName: this.current_contact.first_name,
        TodayDayOfWeek: dayjs().format("dddd"),
      };

      const apptPlaceholders = [
        "ApptLocation",
        "ApptDateWithTime"
      ];
      const hasApptPlaceholders = apptPlaceholders.some((ph) =>  text.includes(`$${ph}`));
    
      if (!hasApptPlaceholders) {
        return text.replace(/\$(\w+)/g, (_, key) => data[key] || `$${key}`);
      }

      this.loadingAppt = true;
       try {
          const apptDetails = await odService.getContactAppointments(this.current_contact.contact_id);
          const appointments = Array.isArray(apptDetails.data) ? apptDetails.data : [];
          const now = dayjs();

          const futureAppointments = appointments
            .filter((appt) => dayjs(appt.AptDateTime).isAfter(now) && appt.AptStatus === "Scheduled")
            .sort((a, b) => dayjs(a.AptDateTime).diff(dayjs(b.AptDateTime)));

          const formattedAppointments = futureAppointments.map((appt) => {
            const apptDateObj = dayjs(appt.AptDateTime);
            const locObj = appt.ClinicLocation;
            const location = locObj
              ? `${locObj.Address}, ${locObj.City}, ${locObj.State} ${locObj.Zip}`
              : "Office";
            return `${apptDateObj.format("dddd, MM/DD/YYYY")} at ${apptDateObj.format("hh:mm A")} Location :(${location})`;
          });
        
          // join multiple appts with "APPT1 and APPT2"
          const apptDateWithTime = formattedAppointments.length > 1
            ? formattedAppointments.slice(0, -1).join(" and ") + " and " + formattedAppointments.slice(-1)
            : formattedAppointments[0] || "";
        
          // replacement data
          const apptData = {
            ApptDateWithTime: apptDateWithTime,
            ApptLocation: futureAppointments[0]
              ? futureAppointments[0].ClinicLocation
                  ? `${futureAppointments[0].ClinicLocation.Address}, ${futureAppointments[0].ClinicLocation.City}, ${futureAppointments[0].ClinicLocation.State} ${futureAppointments[0].ClinicLocation.Zip}`
                  : "Office"
              : "",
            ...data,
          };

          return text.replace(/\$(\w+)/g, (_, key) => apptData[key] || `$${key}`);
        }catch (err) {
            console.error("Error fetching appointment details:", err);
            return text;
          } finally {
            this.loadingAppt = false;
          }
  },
  }
};
</script>

<style scoped>
.mention {
  width: 200px;
  max-height: 200px;
  background: white;
  border: 5px solid #f0f0f0;
  text-align: left;
}

.input-none {
  display: none;
}
.mention {
  width: 200px;
  max-height: 200px;
  background: white;
  border: 5px solid #f0f0f0;
  text-align: left;
  overflow-y: auto;
}

.dropzone {
  border: 2px dashed transparent;
  transition: 0.25s ease;
}

.dropzone.drag-active {
  border-color: #7e57c2;
  background: #f3e5f5;
}

.mention {
  width: 200px;
  max-height: 200px;
  background: white;
  border: 5px solid #f0f0f0;
  overflow-y: auto;
}

.highlighted {
  background-color: #e0e0e0;
}


</style>
